export default "__VITE_ASSET__d9176c1e__"